import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import * as UTIL from "../../util";
export var handleInstagram = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(accountName) {
    var instagramPayload, test;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return UTIL.apiUtil.fetchGet("https://cbapidev.azure-api.net/instagram/v1/media");

          case 2:
            instagramPayload = _context.sent;
            test = instagramPayload.data.map(function (item, index) {
              return {
                linksrc: item.permalink,
                imgsrc: item.media_url
              };
            });
            return _context.abrupt("return", test);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleInstagram(_x) {
    return _ref.apply(this, arguments);
  };
}();